import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { EntityListView } from '@/components/EntityListView';
import { userListService } from '@/services/identity/userListService';
import { buildUserListColumns } from '@/core/UserListColumns';

/**
 * The Users grid, on the same <EntityListView> shell as the generated entity lists: saved views,
 * column filters, bulk delete and keyboard navigation come from the shell. Users are ABP's
 * IdentityUser rather than a DSL entity, so the columns are hand-written and the list reads
 * /api/identity/user-list (see userListService). "Assign roles" and "Log in as" are this entity's
 * toolbar extras (config/listViewExtras).
 */
export function UserListPage() {
  const { t } = useTranslation();
  const columns = useMemo(() => buildUserListColumns(t), [t]);

  return (
    <EntityListView
      module="Core"
      entity="User"
      service={userListService}
      columns={columns}
      gridKey="Core:User"
      titleKey="identity.users"
      title="Users"
      basePath="/core/users"
      defaultSort={[{ field: 'creationTime', sort: 'desc' }]}
      rowGroupingEnabled={false}
    />
  );
}
